import React from 'react';
import { connect } from "react-redux";
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import { withSnackbar } from 'notistack';
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { injectIntl } from "react-intl";
import * as contractDuck from '../../../../store/ducks/contract.duck';
import * as assetCrud from "../../../../crud/asset.crud";
import { listAccountsAllowedRegisterBatchOperations, listAccountsAllowedRegisterBatchOperationsWhenEnabled } from '../../../../router/Protector/AccessExceptions';

class ContractAssets extends React.Component {
    constructor(props) {
        super(props);

        this.batchOperationsEnabled = false;
        if (process.env.REACT_APP_BATCH_OPERATIONS_ENABLED === "true") {
            //REGISTER SUPPORTS BATCH OPERATION
            if (listAccountsAllowedRegisterBatchOperations.includes(this.props.userProfile.accounttype)) {
                this.batchOperationsEnabled = true;
            }
            else if (listAccountsAllowedRegisterBatchOperationsWhenEnabled.includes(this.props.userProfile.accounttype)) {
                this.batchOperationsEnabled = process.env.REACT_APP_REGISTER_BATCH_OPERATIONS_ENABLED === "true";
            }
        }

        this.state = {
            assets: null
        };

        this.columns = [
            { resource: "CONTRACT.EMAILRCP.FIELD.ID", dataField: "AssetID" },
            { resource: 'GENERAL.FORMS.FIELD.ASSET_NAME', dataField: "AssetName" },
            { resource: 'GENERAL.FORMS.FIELD.ASSET_CODE', dataField: "AssetCode" },
            { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "AssetType" },
            { resource: "GENERAL.FORMS.FIELD.IS_ACTIVE", dataField: "IsActive" },
            { resource: "GENERAL.FORMS.FIELD.ASSET_LINK", dataField: "AssetLink", visible: false },
        ];
    }

    componentDidMount() {
        this.loadAssets();
    }

    getFormFieldsOnceDownloadTemplateForBatchButtonClicked = async () => {
        return await this.getFormConfig();
    }

    getFormConfig = async () => {
        const formFields = [
            {
                caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.ASSET_NAME' }),
                dataField: 'AssetName',
                required: true,
                dataType: 'string'
            }
        ];

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.ASSET_CODE' }),
            dataField: 'AssetCode',
            required: true,
            dataType: 'string'
        });

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.ASSET_TYPE' }),
            dataField: 'AssetType',
            required: true,
            dataType: 'string'
        });

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.ASSET_LINK' }),
            dataField: 'AssetLink',
            required: false,
            dataType: 'string'
        });

        return formFields;
    }

    loadAssets = async (forceRefresh) => {
        try {
            const assets = await contractDuck.getAssets(forceRefresh);
            this.setState({ assets: assets });
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
    }
    validateDeactivate = (recordItem) => {
        let allowed = true;
        let error = "";
        if (recordItem.IsActive !== true) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "BATCH_OPS.ERRORS.RECORD_ALREADY_DEACTIVATED" });
        }

        return { allowed, error }
    }
    validateActivate = (recordItem) => {
        let allowed = true;
        let error = "";
        if (recordItem.IsActive !== false) {
            allowed = false;
            error = this.props.intl.formatMessage({ id: "BATCH_OPS.ERRORS.RECORD_ALREADY_ACTIVATED" });
        }

        return { allowed, error }
    }
    onRowPrepared = (e) => {
        if (e.rowType === "data" && e.rowElement) {
            if (e.data?.IsActive === false) {
                e.rowElement.style.backgroundColor = '#ffeeba';
            }
        }
    }
    render() {
        if (!this.state.assets) {
            return (<PortletSpinner />);
        }

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={this.batchOperationsEnabled}
                        batchImportEndpoint={(model) => assetCrud.importAssets(model, this.props.contract.contractid)}
                        batchDeactivateEndpoint={assetCrud.bulkDeactivate}
                        validateDeactivate={this.validateDeactivate}
                        batchActivateEndpoint={assetCrud.bulkActivate}
                        validateActivate={this.validateActivate}
                        batchDeleteEndpoint={(reqObj) => { console.log(reqObj); return 31; }}

                        batchGetFormFieldsWithDownloadTemplateButton={this.getFormFieldsOnceDownloadTemplateForBatchButtonClicked}
                        onBatchRecordsUpdated={this.loadAssets.bind(this, true)}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'NAVIGATION.MENU.ASSETS' })}
                        name={this.props.intl.formatMessage({ id: 'NAVIGATION.MENU.ASSETS' })}
                        dataSource={this.state.assets}
                        keyExpr="AssetID"
                        rowAlternationEnabled={true}
                        columns={this.columns}
                        onRowPrepared={this.onRowPrepared}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}


const mapStateToProps = (store) => ({
    contract: store.contract.contract,
    contractUser: store.contract.user,
    userProfile: store.auth.userProfile
});


export default injectIntl(withSnackbar(connect(mapStateToProps)(ContractAssets)));
